import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { config } from '@/config';
import { PlayerTable } from '@/components/dashboard/player/player-table';

export default function PlayerPage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>Player | Dashboard | {config.site.name}</title>
      </Helmet>
      <Stack spacing={3}>
        <div>
          <Typography variant="h4">Quản Lý Cầu Thủ</Typography>
        </div>
        <PlayerTable />
      </Stack>
    </>
  );
}
